import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ui-btn is-sm is-black is-animated" }
const _hoisted_2 = { class: "ui-btn is-sm is-black is-animated" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, { id: "UiPage" }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(" header ", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_ion_content, { class: "ion-padding" }, {
        default: _withCtx(() => [
          _cache[3] || (_cache[3] = _createElementVNode("p", { class: "UiPage_sectionTitle" }, "rwd font sizes (px presented for large screens)", -1)),
          _cache[4] || (_cache[4] = _createElementVNode("p", { class: "ui-txt-xxs" }, "Text size xxs 15px", -1)),
          _cache[5] || (_cache[5] = _createElementVNode("p", { class: "ui-txt-xs" }, "Text size xs 19px", -1)),
          _cache[6] || (_cache[6] = _createElementVNode("p", { class: "ui-txt-sm" }, "Text size sm 24px", -1)),
          _cache[7] || (_cache[7] = _createElementVNode("p", { class: "ui-txt-md" }, "Text size md 30px", -1)),
          _cache[8] || (_cache[8] = _createElementVNode("p", { class: "ui-txt-lg" }, "Text size lg 44px", -1)),
          _cache[9] || (_cache[9] = _createElementVNode("p", { class: "ui-txt-xl" }, "Text size xl 72px", -1)),
          _cache[10] || (_cache[10] = _createElementVNode("p", { class: "ui-txt-xxl" }, "Text size xxl 90px", -1)),
          _cache[11] || (_cache[11] = _createElementVNode("p", { class: "ui-txt-xxxl" }, "Text size xxxl 140px", -1)),
          _cache[12] || (_cache[12] = _createElementVNode("p", { class: "UiPage_sectionTitle" }, "Buttons", -1)),
          _cache[13] || (_cache[13] = _createElementVNode("p", { class: "ui-btn is-md is-black" }, [
            _createElementVNode("i", { class: "fas fa-home" }),
            _createTextVNode(" Black button ")
          ], -1)),
          _cache[14] || (_cache[14] = _createElementVNode("p", { class: "ui-btn is-md is-black is-animated" }, [
            _createElementVNode("i", { class: "fas fa-home" }),
            _createTextVNode(" Hover animated button ")
          ], -1)),
          _cache[15] || (_cache[15] = _createTextVNode(" Icon button ", -1)),
          _createElementVNode("span", _hoisted_1, [
            _createVNode(_component_ion_icon, { src: _ctx.chevronBackOutline }, null, 8, ["src"]),
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "ui-btn_label" }, "Back", -1))
          ]),
          _createElementVNode("span", _hoisted_2, [
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "ui-btn_label" }, "Next", -1)),
            _createVNode(_component_ion_icon, { src: _ctx.chevronForwardOutline }, null, 8, ["src"])
          ]),
          _cache[16] || (_cache[16] = _createElementVNode("p", { class: "ui-btn is-xxs" }, [
            _createElementVNode("i", { class: "fas fa-home" }),
            _createTextVNode(" Button xxs 15px ")
          ], -1)),
          _cache[17] || (_cache[17] = _createElementVNode("p", { class: "ui-btn is-xs" }, [
            _createElementVNode("i", { class: "fas fa-home" }),
            _createTextVNode(" Button xs 19px ")
          ], -1)),
          _cache[18] || (_cache[18] = _createElementVNode("p", { class: "ui-btn is-sm" }, [
            _createElementVNode("i", { class: "fas fa-home" }),
            _createTextVNode(" Button sm 24px ")
          ], -1)),
          _cache[19] || (_cache[19] = _createElementVNode("p", { class: "ui-btn is-md" }, [
            _createElementVNode("i", { class: "fas fa-home" }),
            _createTextVNode(" Button md 30px ")
          ], -1)),
          _cache[20] || (_cache[20] = _createElementVNode("p", { class: "ui-btn is-lg" }, [
            _createElementVNode("i", { class: "fas fa-home" }),
            _createTextVNode(" Button lg 44px ")
          ], -1)),
          _cache[21] || (_cache[21] = _createElementVNode("p", { class: "ui-btn is-xl" }, [
            _createElementVNode("i", { class: "fas fa-home" }),
            _createTextVNode(" Button xl 72px ")
          ], -1)),
          _cache[22] || (_cache[22] = _createElementVNode("p", { class: "ui-btn is-xxl" }, [
            _createElementVNode("i", { class: "fas fa-home" }),
            _createTextVNode(" Button xxl 90px ")
          ], -1)),
          _cache[23] || (_cache[23] = _createElementVNode("p", { class: "ui-btn is-xxxl" }, [
            _createElementVNode("i", { class: "fas fa-home" }),
            _createTextVNode(" Button xxxl 140px ")
          ], -1))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}